import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { ApiError, apiClient } from '../../lib/api';
import { renderMarkdown } from '../../lib/markdown';
import type { NetworkEvent, PrepDoc } from '../../lib/types';
import { toast } from '../../lib/toast';
import styles from './Briefing.module.css';

interface BriefingPayload {
  event: NetworkEvent;
  prep: PrepDoc;
}

export function BriefingPage() {
  const { eventId } = useParams<{ eventId: string }>();
  const [data, setData] = useState<BriefingPayload | null>(null);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    if (!eventId) return;
    (async () => {
      try {
        const res = await apiClient.get<BriefingPayload>(`/api/v1/briefing/event/${eventId}`);
        setData(res);
      } catch (e) {
        if (e instanceof ApiError) {
          setErr(e.message);
          if (e.status >= 500) toast.error('Не удалось загрузить one-pager.');
        }
      } finally {
        setLoading(false);
      }
    })();
  }, [eventId]);

  if (loading) {
    return <main className={styles.sheet}><p>загружаем one-pager…</p></main>;
  }
  if (err || !data) {
    return (
      <main className={styles.sheet}>
        <p>{err ?? 'one-pager не найден'}</p>
        <Link to="/chat">← к беседе</Link>
      </main>
    );
  }

  const { event, prep } = data;

  return (
    <article className={styles.sheet}>
      <Link to="/chat" className={styles.back}>← беседа</Link>

      <header className={styles.masthead}>
        <div className={styles.left}>Линза</div>
        <div className={styles.mark}>
          Pre&#8209;meeting <span>·</span> <em>Brief</em>
        </div>
        <div className={styles.right}>
          {new Date(event.starts_at).toLocaleDateString('ru-RU', {
            day: '2-digit',
            month: 'long',
            year: 'numeric',
          })}
        </div>
      </header>

      <div className={styles.docMeta}>
        <span>сгенерировано {new Date(prep.generated_at).toLocaleString('ru-RU')}</span>
        <span>{event.location ?? '—'}</span>
        <button className={styles.print} onClick={() => window.print()}>
          печать
        </button>
      </div>

      <h1 className={styles.title}>{event.title}</h1>

      <div
        className={styles.body}
        dangerouslySetInnerHTML={{ __html: renderMarkdown(prep.content) }}
      />
    </article>
  );
}
